module.exports = __webpack_public_path__ + "static/img/jchb1-10.79a4851.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-10.png
// module id = 772
// module chunks = 0